import { arrierePublic } from "@avantstay/arriere-clients/dist/arrierePublic"

interface SubscribeOwnerToMailingListParams {
  email: string
  firstName: string
  source: string
}

interface SubscribeToMailingListParams
  extends SubscribeOwnerToMailingListParams {
  signUpSource: string
}

export const subscribeToMailingList = async ({
  email,
  firstName,
  signUpSource,
  source,
}: SubscribeToMailingListParams) => {
  return await arrierePublic.mutations.subscribeToMailingListV2({
    __args: { email, firstName, signUpSource, source },
  })
}

export const subscribeOwnerToMailingList = async ({
  email,
  firstName,
  source,
}: SubscribeOwnerToMailingListParams) => {
  return await arrierePublic.mutations.subscribeOwnerToMailingList({
    __args: { email, firstName, source },
  })
}
